import * as React from 'react';
import ReactDOM from 'react-dom';
import LoginView from './LoginView';
import { LoginViewProps } from './LoginView';

export const LoginViewRoot = (rootElem: Element, props: LoginViewProps) => {
        ReactDOM.render(<LoginView {...props} />, rootElem);
};
